import styles from './screen.module.scss';
import { Col, Image, Row, Space } from 'antd';
import DateTime from './DateTime';
import Lottie from 'react-lottie';
import pLine from '@assets/SVG/PLine.svg';
import info from '@assets/SVG/info.svg';
import Box from '@assets/SVG/Box.svg';
import Group from '@assets/SVG/Group.svg';
import animationData from '@assets/Json/43_F.json';

export default function FSignBoard() {
	const defaultOptions = {
		loop: true,
		autoplay: true,
		animationData: animationData,
		rendererSettings: {
			preserveAspectRatio: 'xMidYMid slice'
		}
	};

	return (
		<div>
			<Lottie options={defaultOptions} />
		</div>
	);
}

export const Screen4 = () => {
	return (
		<div
			className="screen4"
			style={{
				background: styles.blue,
				height: '100vh',
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center'
			}}
		>
			<div style={{ background: styles.blue }}>
				<div className="textVariantPotraitLarge">Selamat Datang ke Malaysia</div>
				<div className="textVariantPotraitLarge2">Welcome to Malaysia</div>
				<div style={{ display: 'flex', justifyContent: 'center' }}>
					<Row className="direction">
						<Col md={4}>
							<div style={{ width: '390px', height: '900px' }}>
								<FSignBoard />
							</div>
						</Col>
						<Col md={9}>
							<div style={{ marginTop: '350px', textAlign: 'center' }}>
								<Image src={info} preview={false} />
								<div className="infoText">Kaunter Penerangan</div>
								<div className="infoText2">Information Counter</div>
							</div>
						</Col>
						<Col md={3}>
							<div style={{ marginTop: '200px', width: '969px', height: '300px' }}>
								<Image src={Box} preview={false} />
							</div>
						</Col>
					</Row>
				</div>

				<Image style={{marginTop:"64px",height:"40px"}} src={pLine} preview={false} />

				<div style={{ display: 'flex', justifyContent: 'center', margin: '60px' }}>
					<Image src={Group} preview={false} />
				</div>

				<div className="textVariantSectionSmall " style={{ marginTop: '200px' }}>
					<DateTime />
				</div>
			</div>
		</div>
	);
};
